<template>
  <v-container class="container-mobile">
    <v-row class="card">
      <sn-loader
        v-if="loading"
        class="pt-8 pb-8 mt-16 mb-16"
        :loading="true"
        :wait-for-animation="true"
        :speed="1.25"
        :messages="['Please wait...']"
      />
      <template v-else>
        <hero-text
          :logo="companyLogoUrl"
          title="Uh oh... this page is no longer supported"
          subtitle="Please contact your loan officer if you have questions"
        />
      </template>
    </v-row>
  </v-container>
</template>

<script>
import HeroText from './HeroText.vue'
import homehubMixin from '~/components/homehub/Onboarding/Shared/homehubMixin.js'
import SnLoader from '~/components/common/snLoader.vue'

export default {
  name: 'DisabledCompanyBanner',

  components: {
    HeroText,
    SnLoader
  },
  mixins: [homehubMixin],
  props: {
    servicer: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    companyLogoUrl () {
      return this.servicer?.effective_company_logo_url
    }
  },
  mounted () {
    if (this.$route.query.email_token) {
      this.$store.emailToken = this.$route.query.email_token
      this.$router.replace({ path: this.$route.fullPath, query: { ...this.$route.query, email_token: undefined } }) // remove token from url
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~/assets/css/snui";

.card {
  padding: 64px;
  display: flex;
  background-color: $sn-white;
  border-radius: 16px;
}
.action-col h1 {
  margin-top: 35px;
}
.title {
  margin-top: 35px;
  font-size: 48px !important;
}
.subtitle {
  padding-left: 12px;
  margin-top: 16px;
  margin-bottom: 40px;
}
.signin-link {
  cursor: pointer;
  text-decoration: underline;
}
.mobile-underlay {
  display: none;
}

@media screen and (max-width: $medium-screen-size) {
  .container-mobile {
    position: relative;
    border-radius: 16px 16px 0 0;
    background-color: $sn-white;
  }
  .card {
    max-height: inherit;
    flex-direction: column-reverse;
    align-items: center;
    padding: 45px 17px 10px;
  }
  .action-col {
    position: relative;
    margin: 0 -17px;
    padding: 40px 16px;
    border-radius: 8px;
    background-color: $sn-white;
    box-shadow: $sn-shadow-depth-2;
  }
  .servicer-col {
    justify-content: center;
    margin-top: -130px;
  }
  .mobile-underlay {
    display: block;
    position: relative;
    bottom: 0;
    width: 100vw;
    height: 105px;
    margin: -75px -17px 0;
    flex-grow: 100;
    background-color: $sn-gray-01;
  }
}

@media screen and (min-width: ($medium-screen-size + 1)) {
  .card {
    box-shadow: $sn-shadow-depth-3;
  }
}
</style>
